import { AbstractControl } from '@angular/forms';

export class LocationValidator {
  static DestinationInstallationUnitValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const formGroup = control.parent;

    const originDeposit = formGroup.get('originDeposit').value?.key;
    const originInstallationUnit = formGroup.get('originInstallationUnit').value;
    const destinationDeposit = formGroup.get('destinationDeposit').value?.key;
    const destinationInstallationUnit = control.value;

    if(destinationInstallationUnit && originDeposit === destinationDeposit && originInstallationUnit === destinationInstallationUnit) {
      return { 'destination': true };
    }

    return null;
  }
}